import { ComponentPropsWithoutRef, forwardRef } from 'react';

import { Typography } from '@material-ui/core';
import { WithStyles, createStyles, withStyles } from '@material-ui/core/styles';

import classNames from 'classnames';

const styles = () =>
  createStyles({
    root: {},
  });

export interface SectionTitleProps
  extends Omit<ComponentPropsWithoutRef<typeof Typography>, 'classes'>,
    WithStyles<typeof styles> {}

const SectionTitleMui = forwardRef<HTMLDivElement, SectionTitleProps>(
  (props, ref) => {
    const { className, classes, children, ...rest } = props;

    return (
      <Typography
        variant="h5"
        ref={ref}
        className={classNames(className, classes.root)}
        {...rest}
      >
        {children}
      </Typography>
    );
  },
);

SectionTitleMui.displayName = 'SectionMui.Title';

/** @deprecated Legacy MUI copy - migrate consumers to the Encore Section and delete. */
export default withStyles(styles)(SectionTitleMui);
